import Icon from './AppIcon';
import React from "react";
import { Link } from 'react-router-dom';

const Footer = () => (
    <footer className="bg-surface border-t border-border py-8">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
            <div className="flex flex-col md:flex-row justify-between items-center">
                <div className="flex items-center space-x-2 mb-4 md:mb-0">
                    <div className="w-8 h-8 bg-primary rounded-md flex items-center justify-center">
                        <span className="text-white font-bold text-sm">DM</span>
                    </div>
                    <span className="text-text-primary font-semibold">Dishant Madariya</span>
                </div>

                <div className="flex flex-col md:flex-row items-center gap-4 md:gap-6">
                    <div className="flex items-center gap-4 md:gap-6">
                        <Link 
                            to="/blog" 
                            className="text-sm text-text-secondary hover:text-primary transition-colors duration-200"
                        >
                            Blog
                        </Link>
                        <Link 
                            to="/terms-conditions" 
                            className="text-sm text-text-secondary hover:text-primary transition-colors duration-200"
                        >
                            Terms & Conditions
                        </Link>
                        <Link 
                            to="/privacy-policy" 
                            className="text-sm text-text-secondary hover:text-primary transition-colors duration-200"
                        >
                            Privacy Policy
                        </Link>
                    </div>
                    <div className="text-sm text-text-secondary">
                        © {new Date().getFullYear()} Dishant Madariya. All rights reserved.
                    </div>
                </div>
            </div>
        </div>
    </footer>
);

export default Footer;